import React, { useMemo } from 'react';
import BroadcastComposer from './BroadcastComposer';
import { scopedKey } from './scope';

// Agent → one-off email to their own contacts. Transient (nothing saved).
function MessageContacts({ scope, agentName, fileKeys, onBack, signature = '' }) {
  const contacts = useMemo(() => {
    try { return JSON.parse(localStorage.getItem(scopedKey('ira_contacts', scope)) || '[]'); } catch { return []; }
  }, [scope]);

  const recipients = contacts.map(c => {
    const full = `${c.firstName || ''} ${c.lastName || ''}`.trim();
    return {
      id: c.id,
      name: full || c.email || '(no name)',
      email: c.email,
      subs: {
        '{{Contact}}': full,
        '{{First Name}}': c.firstName || '',
        '{{Last Name}}': c.lastName || '',
        '{{Email}}': c.email || '',
      },
    };
  });

  return (
    <BroadcastComposer
      title="Message Contacts"
      subtitle="Send a one-off email to your contacts. This isn't saved as a reminder — it sends now and is done."
      recipients={recipients}
      variables={[
        { key: '{{Contact}}', label: 'Contact' },
        { key: '{{First Name}}', label: 'First Name' },
        { key: '{{Last Name}}', label: 'Last Name' },
      ]}
      fileKeys={fileKeys}
      defaultSubject={`A message from ${agentName || 'your agent'}`}
      recipientNoun="contact"
      emptyMsg="No contacts yet. Import or add contacts first."
      onBack={onBack}
      signature={signature}
      trackContacts
    />
  );
}

export default MessageContacts;
